import axios from "axios";
import qs from "qs"

const state = {
  companies: [],
  companyList: [],
  company: {},
  segmentList: [],
  loading: false,
  companyStatus: [],
  companyStatusReasonType: [],
  showSegmentStatusReason: false,
  importResponse: {},
  statusReasonTypes: {
    "TemporarilyOutOfService": "Geçici olarak kullanım dışı",
    "AbuseOfUse": "Kötüye kullanım",
    "UserComplaint": "Kullanıcı şikayeti",
    "OperationalIssues": "Operasyonel problemler",
    "ContractTermination": "Sözleşme feshi",
    "LowRating": "Düşük puanlama",
    "BusinessTransfer": "İş yeri devri",
    "GdprViolation": "KVKK ihlali"
  },
  companyStatusTypes: {
    "Open": "Açık",
    "Closed": "Kapalı"
  }
};

const getters = {
  allCompanies: (state) => state.companies,
  allCompanyList: (state) => state.companyList,
  companyData: (state) => state.company,
  segmentList: (state) => state.segmentList,
  loading: (state) => state.loading,
  allCompanyStatus: (state) => state.companyStatus,
  allCompanyStatusReasonTypes: (state) => state.companyStatusReasonType,
  showSegmentStatusReason: (state) => state.showSegmentStatusReason,
  importResponse: (state) => state.importResponse,
};

const actions = {
  getCompanies({ commit, state }, filters) {
    commit("setLoading", true);
    const queryString = qs.stringify({
      page: filters.pageNumber,
      size: filters.pageSize,
      search: filters.search,
      isActive: filters.active
    },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== '' ? value : undefined),
      });
    return axios
      .get(
        `/api/panel/company/get-company-list?${queryString}`)
      .then((response) => {
        commit("setCompanies", response.data.payload.items);
        commit("setLoading", false);
        return response.data.payload;
      });
  },
  getCompanieList({ commit }) {
    return axios
      .get(`/api/panel/company/merchant-company-list`)
      .then((response) => {
        commit("setCompanyList", response.data.payload);
        return response.data.payload;
      });
  },
  getCompany({ commit }, company) {
    axios
      .get(`/api/panel/company/company-detail/${company.id}`)
      .then((response) => {
        commit("setCompany", response.data.payload);
        response.data.payload;
      });
  },
  updateCompany({ commit }, company) {
    return axios
      .put(`/api/panel/company/update-company`, company)
      .then((response) => {
        return response.data;
      });
  },
  updateCompanyStatus({ commit }, company) {
    let companyData = {
      id: company.id,
      active: company.active,
    };

    return axios
      .put(`/api/panel/company/change-active-company`, companyData)
      .then((response) => {
        return response.data;
      });
  },
  addCompany({ commit }, company) {
    return axios
      .post(`/api/panel/company/create-company`, company)
      .then((response) => {
        return response.data;
      });
  },
  getCompanySegments({ commit }) {
    return axios.get(`/api/panel/company/segments`).then((response) => {
      commit("setCompanySegmentList", response.data.payload);
      return response.data.payload;
    });
  },
  getCompanyStatus({ commit }) {
    return axios.get(`/api/public/get-enum/CompanyStatus`)
      .then((response) => {
        response.data.payload = response.data.payload.map((status) => {
          return {
            name: state.companyStatusTypes[status],
            value: status
          }
        })
        console.log(response.data.payload);

        commit("setCompanyStatus", response.data.payload);
        return response.data.payload;
      });
  },
  getCompanyStatusReasonType({ commit }) {
    return axios
      .get(`/api/public/get-enum/CompanyStatusReasonType`)
      .then((response) => {
        response.data.payload = response.data.payload.map((reason) => {
          return {
            name: state.statusReasonTypes[reason],
            value: reason
          }
        })
        commit("setCompanyStatusReasonType", response.data.payload);
        return response.data.payload;
      });
  },
  setShowSegmentStatusReasonAction({ commit }, value) {
    commit("setShowSegmentStatusReason", value);
  },
  async importCompanies({ commit }, file) {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await axios.post(
        "/api/panel/company/import",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      commit("setImportResponse", {
        success: !response.data.payload.message,
        message: response.data.payload.message,
        logFileUrl: response.data.payload.url,
      });
    } catch (error) {
      commit("setImportResponse", {
        success: false,
        message: "An error occurred while processing your request.",
      });
    }
  },
  exportCompanyTemplate({ commit }) {
    axios({
      url: `https://frink.mncdn.com/template/company-excel-template.xlsx`,
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `company-template.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  },
  downloadCompanyLogFile({ commit }, url) {
    axios({
      url: url,
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `company-error-log-${new Date().toISOString().substr(0, 10)}.txt`
      );
      document.body.appendChild(link);
      link.click();
    });
  },
  exportCompanies({ commit }, filters) {
    const queryString = qs.stringify({
      search: filters.search,
      isActive: filters.isActive
    },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== '' ? value : undefined),
      });

    console.log("queryString", queryString);
    axios({
      url: `/api/panel/company/export?${queryString}`,
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Company-${new Date().toISOString().substr(0, 10)}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
    });
  },
};

const mutations = {
  setCompanies: (state, companies) => {
    companies.forEach((company) => {
      if (company.companyStatus == "0") {
        if (company.companyStatusReasonType) {
          company.companyStatus =
            "Açık (" + state.companyStatusReasonType[parseInt(company.companyStatusReasonType)].name + ")";
        }
        else {
          company.companyStatus = "Açık"
        }
      }
      else if(company.companyStatus == "1"){
        if (company.companyStatusReasonType) {
          company.companyStatus =
            "Kapalı (" + state.companyStatusReasonType[parseInt(company.companyStatusReasonType)].name + ")";
        }
        else {
          company.companyStatus = "Kapalı"
        }
      }
    });
    state.companies = companies;
  },
  setCompanyList: (state, companies) => {
    state.companyList = companies;
  },
  setCompany: (state, company) => {
    state.company = company;
    if (company.companyStatus === "1") {
      state.showSegmentStatusReason = true;
    } else {
      state.showSegmentStatusReason = false;
    }
  },
  setCompanySegmentList: (state, segments) => {
    state.segmentList = segments;
  },
  setLoading(state, value) {
    state.loading = value;
  },
  setCompanyStatus(state, value) {
    state.companyStatus = value;
  },
  setCompanyStatusReasonType(state, value) {
    state.companyStatusReasonType = value;
  },
  setShowSegmentStatusReason(state, value) {
    state.showSegmentStatusReason = value;
  },
  setImportResponse(state, importResponse) {
    state.importResponse = importResponse;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
